import { TabsNavigation } from '@components/_shared/tabsNavigation';
import { Gallery } from '@components/_shared/gallery';
import { useGetDevice } from '@utils/hooks/useGetDevice';
import { BaseComponentProps } from '@utils/types/baseComponents';
import { SpacesPhotos } from '@utils/types/listing';
import clsx from 'clsx';
import React, { useState } from 'react';
import styles from './styles.module.scss';

type Props = {
  spaces: SpacesPhotos[];
} & BaseComponentProps;

ImageSelector.defaultProps = {};

export function ImageSelector(props: Props) {
  const { containerStyle, spaces } = props;
  const device = useGetDevice();
  const [selectedSpace, setSelectedSpace] = useState(spaces[0].title);
  return (
    <div className={clsx([styles.imageSelectorContainer, containerStyle])}>
      <div className={styles.selector}>
        {['laptop', 'default'].includes(device) ? (
          spaces.map(({ title }, index) => (
            <div
              onClick={() => setSelectedSpace(title)}
              key={index}
              className={clsx(
                styles.option,
                selectedSpace === title && styles.selected
              )}
            >
              {title}
            </div>
          ))
        ) : (
          <TabsNavigation
            tabs={spaces
              .filter(({ images }) =>
                images?.some((i) => i.asset && i.asset.url)
              )
              .map(({ title }) => ({
                label: title,
                onClick: () => setSelectedSpace(title),
              }))}
          />
        )}
      </div>
      <div className={styles.gallery}>
        <Gallery
          images={(spaces.find((v) => v.title === selectedSpace)?.images || [])
            .filter((i) => i.asset && i.asset.url)
            .map((v) => v.asset.url)}
        />
      </div>
    </div>
  );
}
